module.exports = __webpack_public_path__ + "img/page7.62bfe3bc.png";